import { OrganisationModelGqlBase } from 'front-end/src/graphql/public/PublicSchemaTypes'
import { IOrganisationLogo } from 'types/Organisation'

export function getImageVariant(
  logoObj: IOrganisationLogo | null | undefined,
  size: string
): string | null {
  if (logoObj) {
    if (logoObj.variants && logoObj.variants[size]) {
      return logoObj.variants[size]
    } else if (logoObj.original) {
      return logoObj.original
    } else {
      return null
    }
  }
  return null
}

// TODO will this ever be used?
export function getLogoSrcSet(organisation) {
  const srcSet = {
    '1x': getImageVariant(organisation && organisation.styles.logo, '300x200'),
    '2x': getImageVariant(organisation && organisation.styles.logo, '600x300')
  }
  return Object.keys(srcSet)
    .reduce((arr, density) => {
      if (srcSet[density]) {
        return arr.concat(`${srcSet[density]} ${density}`)
      }
      return arr
    }, [] as string[])
    .join(', ')
}

export function getOrganisationLogoSrc(
  organisation:
    | ({ __typename?: 'OrganisationModelGQLBase' | undefined } & Pick<
        OrganisationModelGqlBase,
        'name' | 'color' | 'styles'
      >)
    | undefined
    | null
) {
  const src = getImageVariant(organisation?.styles?.logo, '600x300')
  // hackfix for a prod issue TODO remove
  if (
    src &&
    src.startsWith('organisation-') &&
    process.env.LOOOP_ENVIRONMENT === 'prod'
  ) {
    return `https://public-cdn.looop.co/${src}`
  }

  return src as string
}
